import { render, staticRenderFns } from "./DomainSubdomain.vue?vue&type=template&id=fcfbd0bc&"
import script from "./DomainSubdomain.vue?vue&type=script&lang=js&"
export * from "./DomainSubdomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports